import angular from 'angular';

class PopupController {
  private isActive: boolean;
  constructor(private $element: ng.IAugmentedJQuery, private $timeout: ng.ITimeoutService) {}
  $onChanges() {
    if (this.isActive) {
      const popupEl = this.$element.find('hi-tile')[0];
      if (popupEl) {
        this.$timeout(() => {
          popupEl.focus();
        }, 200);
      }
    }
  }
}
export class PopupComponent implements angular.IComponentOptions {
  public templateUrl: string = 'ui-ng-popup/src/components/popup/popup.html';
  public controller: any = PopupController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    isActive: '<',
    title: '<',
    body: '<?',
    completeButtonText: '<?',
    cancelButtonText: '<?',
    completeCallback: '&?',
    cancelCallback: '&?',
    acceptOnly: '<?'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-popup/src/components/popup/popup.ts